export default __webpack_public_path__ + "static/Data-Driven-77a19775c677678458f8fbd3fe0f225a.png";